// src/theme.ts
import { createTheme } from '@mui/material/styles';

const rootElement = document.getElementById('root');
// All `Portal`-related components need to have the the main app wrapper element as a container
// so that the are in the subtree under the element used in the `important` option of the Tailwind's config.
const theme = createTheme({
  cssVariables: true,
  components: {
    MuiPopover: {
      defaultProps: {
        container: rootElement,
      },
    },
    MuiPopper: {
      defaultProps: {
        container: rootElement,
      },
    },
    MuiButton: {
      defaultProps: {
        style: {
          fontWeight: 700,
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        style: {
          fontWeight: 700,
        },
      },
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#D9D9D9',
          },
        },
      },
    },
  },
  typography: {
    fontFamily: "'Meiryo UI', Meiryo, sans-serif", // Default font for MUI components
    fontWeightMedium: 400,
  },
  palette: {
    text: {
      primary: '#1E1E1E',
      secondary: '#757575',
      disabled: '#B3B3B3',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
});

export default theme;
